<div class="hunt-package">
  <kendo-card width="100%">
    <kendo-card-header class="k-hstack">
      <div class="row">
        <div class="col-lg-12">
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="inactive"
            >Hunt Package</hyperkit-typography
          >
        </div>
        <div class="col-lg-12">
          <package-header>
            <header-title>
              <cyborg-trial-lock-unlock
                [huntPackage]="data"
              ></cyborg-trial-lock-unlock>
            </header-title>
            <header-options>
              @if (data.severity) {
                <hyperkit-badge
                  indicator="dot"
                  [variant]="data.severity | severityBadge"
                  size="large"
                  [text]="data.severity"
                ></hyperkit-badge>
              }
              @if (favorited) {
                <i
                  class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
                  (click)="unfavorite()"
                ></i>
              }
              @if (!favorited) {
                <i
                  class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
                  (click)="favorite()"
                ></i>
              }
              <div class="options">
                @if (huntModuleAccess) {
                  @if (huntCompatible) {
                    <hyperkit-button-menu
                      variant="standard"
                      iconPosition="right"
                      color="tertiary"
                      size="small"
                      icon="chevron-down"
                      text="Hunt"
                    >
                      <hyperkit-dropdown-menu-item
                        (click)="addToExistingTemplate()"
                        value="archive"
                        label="Existing Hunt Template"
                      ></hyperkit-dropdown-menu-item>
                      <hyperkit-dropdown-menu-item
                        (click)="addToExistingQuickHunt()"
                        value="update"
                        label="Existing Hunt"
                      ></hyperkit-dropdown-menu-item>
                      <hyperkit-dropdown-menu-item
                        (click)="addToNewTemplate()"
                        value="archive"
                        label="New Hunt Template"
                      ></hyperkit-dropdown-menu-item>
                      <hyperkit-dropdown-menu-item
                        (click)="addToNewQuickHunt()"
                        value="update"
                        label="New Hunt"
                      ></hyperkit-dropdown-menu-item>
                    </hyperkit-button-menu>
                  }
                } @else {
                  <hyperkit-button
                    (click)="openHuntDialog()"
                    size="small"
                    text="Hunt"
                    color="secondary"
                    [customImage]="'/assets/img/icons/cyborg-premium.png'"
                    [variant]="'standard'"
                  ></hyperkit-button>
                }
              </div>
            </header-options>
          </package-header>
          <package-description>
            <hyperkit-typography
              variant="body"
              size="md"
              align="left"
              color="body"
              >{{ data.description }}</hyperkit-typography
            >
            <div class="meta">
              <div class="date">
                <hyperkit-badge variant="neutral" text="Created">
                </hyperkit-badge>
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >{{
                    data.created_date | date: 'longDate'
                  }}</hyperkit-typography
                >
              </div>
              <div>
                <hyperkit-badge variant="neutral" text="Updated">
                </hyperkit-badge>
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                >
                  {{
                    data.last_updated | date: 'longDate'
                  }}</hyperkit-typography
                >
              </div>
              @if (data.context.threat_categories.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Threat Category"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{
                      data.context.threat_categories.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.context.target_industries.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Industry"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{
                      data.context.target_industries.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.mapping.kill_chains.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Kill Chain"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ data.mapping.kill_chains }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.mapping.mitre.mitre_attack_techniques.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="MITRE Techniques"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                  >
                    {{
                      data.mapping.mitre.mitre_attack_techniques.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.mapping.mitre.mitre_attack_tactics.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="MITRE Tactics"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                  >
                    {{
                      data?.mapping?.mitre?.mitre_attack_tactics.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.context.threat_names.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Threat Names"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{
                      data.context.threat_names.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              }
              @if (data.dependencies.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Dependencies"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ data?.dependencies.join(', ') }}</hyperkit-typography
                  >
                </div>
              }
            </div>
            @if (tags.length > 0) {
              <div>
                <cyborg-facet-buttons
                  [closable]="false"
                  class="tile-facets"
                  [facets]="tags"
                  [groupByCategory]="false"
                ></cyborg-facet-buttons>
              </div>
            }
          </package-description>
        </div>
      </div>
    </kendo-card-header>
  </kendo-card>
</div>
